module.exports = __webpack_public_path__ + "static/media/arbutus-greenway-cropped.684f3b07.jpg";